import { Search } from '@carbon/react';
import { useMemo, useState } from 'react';
import classNames from 'classnames';
import { useDatasetConfig } from '../dataset-context';
import style from './filter-modal.module.scss';

interface Props {
  activeCategory: string;
  onSelect: (id: string) => void;
}

export const FilterCategoryList = ({ activeCategory, onSelect }: Props) => {
  const config = useDatasetConfig();
  const [search, setSearch] = useState('');

  // Unique categories from the filter config, sorted alphabetically
  const categories = useMemo(() => {
    const unique = new Set(config.filters.map((f) => f.category));
    return [...unique].sort((a, b) => a.localeCompare(b));
  }, [config.filters]);

  const filtered = categories.filter((cat) =>
    cat.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <Search
        labelText="Search filters"
        placeholder="Search Filter Names"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <ul className={style.categoryList}>
        {filtered.map((cat) => (
          <li key={cat} className={style.categoryItem}>
            <button
              onClick={() => onSelect(cat)}
              className={classNames(style.categoryButton, {
                [style.categoryButtonActive]: activeCategory === cat,
              })}
            >
              {cat}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
